


















































import { Component, Prop, Vue } from 'vue-property-decorator'
import Glass from '@/data/glass'
import '@/icons/check'
import { BasketType } from '@/data/enums'
@Component({})
export default class GlassTile extends Vue {
  @Prop({ default: false }) private hasInfo?: boolean
  @Prop() private item!: Glass
  @Prop({ default: 0 }) private index!: number
  @Prop({ default: true }) private show!: boolean

  private onInfoClick () {
    if (!this.selected || !this.item.available) {
      return
    }
    this.$emit('showInformation', this.item)
  }

  private get showPrice (): boolean {
    if (this.$store.state.data.optician.showPrices) {
      const type = this.$store.state.data.optician.basketType
      switch (type) {
        case BasketType.None:
          return false
        case BasketType.Total:
          return true
        case BasketType.Current:
          return true
        case BasketType.Amount:
          return true
      }
      return true
    } else {
      return false
    }
  }

  private get selected () {
    return this.item.selected
  }

  private get checked () {
    const internalId = this.item.id
    const items = this.$store.state.cart.items
    if (items && items.length > 0) {
      const glassItem = items.find((glass: Glass) => glass.id === internalId)
      if (glassItem) {
        return true
      }
    }
    return false
  }

  private get selectedPrice () {
    const internalId = this.item.id
    const items = this.$store.state.cart.items
    if (items && items.length > 0) {
      const glassItem = items.find((glass: Glass) => glass.id === internalId)
      if (glassItem) {
        return glassItem.price
      }
    }
    return 0
  }

  private get hasDiscount (): boolean {
    if (this.discountPrice > 0) {
      return true
    }
    return false
  }

  private get discountPrice (): number {
    const internalId = this.item.id
    const items = this.$store.state.cart.items
    if (items && items.length > 0) {
      const glassItem = items.find((glass: Glass) => glass.id === internalId)
      if (glassItem) {
        return glassItem.discountPrice
      }
    }
    return 0
  }

  private onClick () {
    if (this.item.glassTypes.length) {
      if (!this.selected || !this.item.available) {
        return
      }
      // check amount of items in cart
      const count = this.$store.state.cart.items.length
      let path = '/glasses/dneye'

      const hasDneye = this.$store.state.data.optician.dneye
      const hasImpressionist = this.$store.state.data.optician.impressionist

      if (!hasDneye && !hasImpressionist) {
        path = '/glasses/glass'
      }

      // check if optician has dneye
      if (!hasDneye && hasImpressionist) {
        path = '/glasses/impressionist'
      }

      if (count >= 1) { // skip if more then 1 items
        path = '/glasses/glass'
      }
      this.$store.dispatch('cart/configureGlasses', this.item)
        .then(() => this.$router.push(path))
        .catch((err) => console.error(err))
    } else {
      this.$emit('showInformation', this.item)
    }
  }
}
